var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings (2) 1",
    clipPath: "url(#clip0_280_542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.0016 17C30.0016 16.2992 29.9435 15.6118 29.8335 14.9415L34 11.9925L29.9043 5.00759L25.226 7.08646C24.1496 6.21953 22.9294 5.51962 21.6061 5.02583L21.0957 0H12.9043L12.3939 5.02575C11.0706 5.51955 9.85034 6.21946 8.77396 7.08638L4.09569 5.00752L0 11.9925L4.16653 14.9415C4.05646 15.6118 3.99841 16.2992 3.99841 17C3.99841 17.7009 4.05653 18.3882 4.16653 19.0585L0 22.0075L4.09569 28.9924L8.77403 26.9135C9.85041 27.7805 11.0706 28.4804 12.3939 28.9742L12.9043 34H21.0956L21.6061 28.9742C22.9294 28.4804 24.1496 27.7805 25.226 26.9136L29.9043 28.9925L34 22.0075L29.8335 19.0585C29.9435 18.3882 30.0016 17.7009 30.0016 17ZM9.17056 19.0925L6.38583 16.7701L7.77786 15.1008L8.74243 15.9052C9.21073 12.3413 12.0218 9.42301 15.5541 8.80019C18.3864 8.30065 21.2329 9.27503 23.1686 11.4061L21.5597 12.8675C20.1287 11.292 18.0246 10.5719 15.9315 10.9407C13.2615 11.4114 11.1597 13.6541 10.8797 16.3568L12.3638 15.4422L13.5042 17.2926L10.4368 19.183C10.2611 19.2912 9.72262 19.5326 9.17056 19.0925ZM26.2221 18.8992L25.2576 18.0948C24.7893 21.6587 21.9782 24.5771 18.4459 25.1998C15.5086 25.7177 12.4423 24.5781 10.5532 22.2714L12.2348 20.8942C13.6446 22.6156 15.88 23.4452 18.0685 23.0593C20.7385 22.5886 22.8403 20.3458 23.1204 17.6432L21.6363 18.5578L20.4958 16.7074L23.5632 14.817C23.9609 14.5721 24.4706 14.6083 24.8294 14.9075L27.6142 17.2299L26.2221 18.8992Z",
    fill: "#00FFF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg1);
export default __webpack_public_path__ + "static/media/svg1.6c092261c1abd395ece77a14fab7e537.svg";
export { ForwardRef as ReactComponent };